const KEY='fd_support_staff_view';
export function captureSupportStaffViewFromUrl():void {
  const params=new URLSearchParams(window.location.hash.slice(1)),token=params.get('support_view');
  if(!token)return;
  try{sessionStorage.setItem(KEY,token);}catch{/* Memory/private-mode storage may be unavailable. */}
  params.delete('support_view');
  window.history.replaceState(null,'',window.location.pathname+window.location.search+(params.size?'#'+params.toString():''));
}
export function getSupportStaffViewToken():string|null{try{return sessionStorage.getItem(KEY);}catch{return null;}}
export function clearSupportStaffView():void{try{sessionStorage.removeItem(KEY);}catch{/* no storage */}}
